import React, { Component } from "react"
import "./style.scss";

import MasterMixPosterImg from "./img/Table_Poster.svg"
import ThermocyclerPosterImg from "./img/Cycler_Poster.svg"

export class Poster extends Component {

  componentWillMount(){
    this.props.createPoster({
      props: this.props.defaultProps
    })
  }

  showPosterModal = () => {

    this.props.setModal({
      type: (this.props.type === "Thermocycler poster")?'THERMOCYCLER_POSTER':'MASTERMIX_POSTER',
      size: 'cover'
    });

    this.props.showModal({display: true});
  };

  render() {
      return (
        <ul>
          <li
              id={"Poster_"+this.props.id}
              className="Poster"
              onClick={this.showPosterModal}
              aria-label={this.props.altText}
              >
              <p
                aria-hidden="true"
                className="label"
              >{this.props.type}</p>
              <img
                style={{width: "100px", pointerEvents: "none"}}
                src={((this.props.type === "Thermocycler poster")?ThermocyclerPosterImg:MasterMixPosterImg)}
                alt={this.props.type}
                draggable="false"
              />
          </li>
        </ul>
      )
  }
}
